// Local pilot is intentionally opt-in for production builds.
export const businessPilotEnabled = process.env.VUE_APP_BUSINESS_PILOT === 'true'
